type Props = {
  icon: "stats" | "course" | "notification";
};
const TabIcon: React.FC<Props> = ({ icon }) => {
  switch (icon) {
    case "stats":
      return (
        <svg
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.16216 4.11111H2.10991C1.7214 4.11111 1.52715 4.11111 1.37876 4.19588C1.24824 4.27045 1.14211 4.38944 1.07561 4.53579C1 4.70216 1 4.91996 1 5.35556V13.7556C1 14.1912 1 14.4089 1.07561 14.5753C1.14211 14.7217 1.24824 14.8407 1.37876 14.9152C1.52715 15 1.72141 15 2.10991 15H5.16216M5.16216 15H9.32432M5.16216 15L5.16216 2.24444C5.16216 1.80885 5.16216 1.59105 5.23777 1.42467C5.30428 1.27833 5.4104 1.15934 5.54093 1.08477C5.68932 1 5.88357 1 6.27207 1L8.21441 1C8.60292 1 8.79717 1 8.94556 1.08477C9.07609 1.15934 9.18221 1.27833 9.24872 1.42467C9.32433 1.59105 9.32432 1.80885 9.32432 2.24444V15M9.32432 7.22222H12.3766C12.7651 7.22222 12.9593 7.22222 13.1077 7.30699C13.2383 7.38156 13.3444 7.50055 13.4109 7.6469C13.4865 7.81327 13.4865 8.03107 13.4865 8.46667V13.7556C13.4865 14.1912 13.4865 14.4089 13.4109 14.5753C13.3444 14.7217 13.2383 14.8407 13.1077 14.9152C12.9593 15 12.7651 15 12.3766 15H9.32432"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "course":
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.12"
            d="M11.0114 1L6.60877 7.91076C6.4139 8.21663 6.31647 8.36957 6.32069 8.49708C6.32436 8.6081 6.37184 8.71154 6.45027 8.77942C6.54037 8.85738 6.70799 8.85738 7.04325 8.85738H10.3439L9.67653 14.4698L14.0791 7.55903C14.274 7.25316 14.3714 7.10022 14.3672 6.97271C14.3635 6.86169 14.3161 6.75825 14.2376 6.69037C14.1475 6.61241 13.9799 6.61241 13.6447 6.61241H10.3439L11.0114 1Z"
            fill="currentColor"
          />
          <path
            d="M5.67195 11.8507H2.00113M4.0034 7.7349H1M5.67195 3.61913H2.33484M11.0113 1L6.60873 7.91076C6.41386 8.21663 6.31643 8.36957 6.32065 8.49708C6.32432 8.6081 6.3718 8.71154 6.45023 8.77942C6.54033 8.85738 6.70795 8.85738 7.04321 8.85738H10.3439L9.67649 14.4698L14.0791 7.55903C14.274 7.25316 14.3714 7.10022 14.3672 6.97271C14.3635 6.8617 14.316 6.75825 14.2376 6.69037C14.1475 6.61241 13.9799 6.61241 13.6446 6.61241H10.3439L11.0113 1Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "notification":
      return (
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.12"
            d="M11.3981 6.55145C11.1599 5.55458 10.5239 4.72098 9.63003 4.23402C8.73616 3.74707 7.65766 3.64664 6.63178 3.95484C5.60591 4.26305 4.71668 4.95463 4.15973 5.87745C3.60278 6.80027 3.42373 7.87874 3.66196 8.87561C4.05612 10.5249 3.97958 11.8408 3.73067 12.8406C3.44697 13.9802 3.30512 14.55 3.34344 14.6644C3.38728 14.7953 3.419 14.8313 3.53529 14.8818C3.63693 14.9259 4.06393 14.7977 4.91792 14.5411L12.8369 12.162C13.6909 11.9054 14.1179 11.7772 14.1863 11.6819C14.2644 11.573 14.2759 11.5241 14.2555 11.3862C14.2376 11.2656 13.8607 10.8517 13.1068 10.0238C12.4454 9.29742 11.7923 8.20079 11.3981 6.55145Z"
            fill="currentColor"
          />
          <path
            d="M10.1669 12.9648C10.4531 14.1625 9.81922 15.3935 8.75108 15.7144C7.68294 16.0353 6.58502 15.3245 6.29881 14.1269M1.09724 8.17448C0.837287 7.12819 1.10762 5.997 1.79934 5.23662M7.83118 3.77999C8.03422 3.37044 8.1011 2.87542 7.98439 2.38707C7.74589 1.38906 6.83096 0.796794 5.94084 1.06421C5.05072 1.33163 4.52249 2.35746 4.76099 3.35547C4.8777 3.84382 5.15637 4.23502 5.51484 4.47589M13.2858 4.51271C13.0444 3.46086 12.3058 2.63277 11.3677 2.36205M11.3981 6.5521C11.1599 5.55524 10.5239 4.72163 9.63 4.23468C8.73614 3.74772 7.65764 3.6473 6.63176 3.9555C5.60588 4.2637 4.71666 4.95528 4.15971 5.87811C3.60276 6.80093 3.42371 7.8794 3.66194 8.87626C4.0561 10.5256 3.97956 11.8414 3.73065 12.8413C3.44695 13.9809 3.3051 14.5507 3.34342 14.6651C3.38726 14.796 3.41898 14.8319 3.53527 14.8824C3.63691 14.9266 4.06391 14.7983 4.9179 14.5417L12.8369 12.1627C13.6909 11.9061 14.1179 11.7778 14.1862 11.6826C14.2644 11.5737 14.2759 11.5248 14.2555 11.3868C14.2376 11.2662 13.8607 10.8523 13.1068 10.0244C12.4453 9.29808 11.7923 8.20144 11.3981 6.5521Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
  }
};
export default TabIcon;
